<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow">
            <div
              class="card-header card-header-primary negative blue-grad w-50"
            >
              <h4 class="card-title">{{ $t("message.twh.new") }}</h4>
            </div>
            <div class="card-body px-3">
              <router-link
                :to="{ name: 'twh-index' }"
                class="ml-md-auto float-right mb-4 btn btn-outline-default btn-outline btn-round btn-rounded btn-pill"
                id="add-new-twh"
                title-link-class="btn-outline-default text-white"
                >{{ $t("message.cancel") }}</router-link
              >
              <div class="clear" style="clear: both"></div>
              <div class="form">
                <div class="row">
                  <div class="col-md-6">
                    <span
                      :class="['bmd-form-group mb-1 d-block form-label-group']"
                    >
                      <label
                        for="twh_docid"
                        :class="[
                          'form-label-group-label shorter',
                          twh.docid != '' ? 'high' : '',
                        ]"
                        >{{ $t("message.twh.docid") }}</label
                      >
                      <cleave
                        id="twh_docid"
                        v-model="twh.docid"
                        :options="cleave"
                        class="form-control"
                        :placeholder="$t('message.twh.docid')"
                        autocomplete="off"
                        style="cursor: auto"
                      ></cleave>
                    </span>
                  </div>

                  <div class="col-md-6">
                    <span
                      :class="['bmd-form-group mb-1 d-block form-label-group']"
                    >
                      <label
                        for="twh_createyear"
                        :class="[
                          'form-label-group-label shorter',
                          twh.createyear != '' ? 'high' : '',
                        ]"
                        >{{ $t("message.twh.createyear") }}</label
                      >
                      <cleave
                        id="twh_createyear"
                        v-model="twh.createyear"
                        :options="cleave"
                        class="form-control"
                        :placeholder="$t('message.twh.createyear')"
                        autocomplete="off"
                        style="cursor: auto"
                      ></cleave>
                    </span>
                  </div>

                  <div class="col-md-6">
                    <span
                      :class="['bmd-form-group mb-2 d-block form-label-group']"
                    >
                      <input
                        type="text"
                        class="form-control"
                        v-model="twh.blankinnum"
                        :placeholder="$t('message.twh.blankinnum')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_blankinnum"
                      />
                      <label
                        for="twh_blankinnum"
                        class="form-label-group-label shorter"
                        >{{ $t("message.twh.blankinnum") }}</label
                      >
                    </span>
                  </div>

                  <div class="col-md-6">
                    <span
                      :class="['bmd-form-group mb-2 d-block form-label-group']"
                    >
                      <input
                        type="text"
                        maxlength="3"
                        class="form-control"
                        v-model="twh.purpose"
                        :placeholder="$t('message.twh.purpose')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_purpose"
                      />
                      <label
                        for="twh_purpose"
                        class="form-label-group-label shorter"
                        >{{ $t("message.twh.purpose") }}</label
                      >
                    </span>
                  </div>
                </div>
                <hr />
                <h5>{{ $t("message.twh.transport") }}</h5>
                <div class="row">
                  <div class="col-md-3">
                    <span
                      :class="['bmd-form-group mb-2 d-block form-label-group']"
                    >
                      <input
                        type="text"
                        maxlength="3"
                        class="form-control"
                        v-model="twh.transcategorycode"
                        :placeholder="$t('message.twh.transcategorycode')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_transcategorycode"
                      />
                      <label
                        for="twh_transcategorycode"
                        class="form-label-group-label shorter"
                        >{{ $t("message.twh.transcategorycode") }}</label
                      >
                    </span>
                  </div>
                  <div class="col-md-3">
                    <span
                      :class="['bmd-form-group mb-2 d-block form-label-group']"
                    >
                      <input
                        type="text"
                        maxlength="30"
                        class="form-control"
                        v-model="twh.transtype"
                        :placeholder="$t('message.twh.transtype')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_transtype"
                      />
                      <label
                        for="twh_transtype"
                        class="form-label-group-label shorter"
                        >{{ $t("message.twh.transtype") }}</label
                      >
                    </span>
                  </div>
                  <div class="col-md-3">
                    <span
                      :class="['bmd-form-group mb-2 d-flex align-items-center']"
                    >
                      <input
                        type="checkbox"
                        maxlength="30"
                        class="mr-2"
                        v-model="twh.trisleave"
                        :placeholder="$t('message.twh.transtype')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_trisleave"
                      />
                      <label
                        for="twh_trisleave"
                        class="form-label-group-label mb-0 shorter"
                        >{{ $t("message.twh.trisleave") }}</label
                      >
                    </span>
                  </div>

                  <div class="col-md-3">
                    <span
                      :class="[
                        'bmd-form-group mb-2 d-block form-label-group shorter',
                      ]"
                    >
                      <datepicker
                        value-type="YYYY-MM-DD"
                        format="DD.MM.YYYY"
                        @focus="twh.dateout = ' '"
                        @blur="
                          twh.dateout == ' '
                            ? (twh.dateout = '')
                            : (twh.dateout = twh.dateout)
                        "
                        inputClass="form-control"
                        v-model="twh.dateout"
                        :placeholder="$t('message.twh.dateout')"
                        :inputAttr="{ id: 'twh_dateout' }"
                      />
                      <label
                        for="twh_dateout"
                        class="form-label-group-label shorter"
                        :class="
                          twh.dateout != '' && twh.dateout != null
                            ? 'topped'
                            : ''
                        "
                        >{{ $t("message.twh.dateout") }}</label
                      >
                    </span>
                  </div>

                  <div class="col-md-12">
                    <span
                      :class="[
                        'bmd-form-group mb-2 mt-2 d-block form-label-group ',
                        focused.regcountry == true ? 'focused' : '',
                      ]"
                    >
                      <v-select-popup
                        type="country"
                        :placeholder="$t('message.twh.regcountry')"
                        v-model="twh.regcountry"
                      />
                      <!-- <v-select id="twh_regcountry" :options="countries" label="display_text" :class="['form-control', typeof twh.regcountry !== 'undefined' && twh.regcountry.value!==''?'vs--selected':'']" @search="fetchCountries"  v-model="twh.regcountry" :placeholder="$t('message.twh.regcountry')" @focus="focused.regcountry=true" @blur="focused.regcountry=false">
                                            </v-select>	
                                            <label for="twh_regcountry" class="form-label-group-label shorter">{{$t('message.twh.regcountry')}}</label> -->
                    </span>
                  </div>

                  <div class="col-md-6">
                    <span
                      :class="['bmd-form-group mb-2 d-block form-label-group']"
                    >
                      <input
                        type="text"
                        maxlength="255"
                        class="form-control"
                        v-model="twh.transportmark"
                        :placeholder="$t('message.twh.transportmark')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_transportmark"
                      />
                      <label
                        for="twh_transportmark"
                        class="form-label-group-label shorter"
                        >{{ $t("message.twh.transportmark") }}</label
                      >
                    </span>
                  </div>

                  <div class="col-md-6">
                    <span
                      :class="['bmd-form-group mb-2 d-block form-label-group']"
                    >
                      <input
                        type="text"
                        maxlength="30"
                        class="form-control"
                        v-model="twh.transportnum"
                        :placeholder="$t('message.twh.transportnum')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_transportnum"
                      />
                      <label
                        for="twh_transportnum"
                        class="form-label-group-label shorter"
                        >{{ $t("message.twh.transportnum") }}</label
                      >
                    </span>
                  </div>

                  <div class="col-md-6">
                    <span
                      :class="['bmd-form-group mb-2 d-block form-label-group']"
                    >
                      <input
                        type="text"
                        maxlength="50"
                        class="form-control"
                        v-model="twh.trailernum"
                        :placeholder="$t('message.twh.trailernum')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_trailernum"
                      />
                      <label
                        for="twh_trailernum"
                        class="form-label-group-label shorter"
                        >{{ $t("message.twh.trailernum") }}</label
                      >
                    </span>
                  </div>

                  <div class="col-md-6">
                    <span
                      :class="['bmd-form-group mb-2 d-block form-label-group']"
                    >
                      <input
                        type="text"
                        maxlength="50"
                        class="form-control"
                        v-model="twh.shassi"
                        :placeholder="$t('message.twh.shassi')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_shassi"
                      />
                      <label
                        for="twh_shassi"
                        class="form-label-group-label shorter"
                        >{{ $t("message.twh.shassi") }}</label
                      >
                    </span>
                  </div>
                </div>
                <hr />
                <h5>{{ $t("message.twh.driver") }}</h5>
                <div class="row">
                  <div class="col-md-6">
                    <span
                      :class="['bmd-form-group mb-2 d-block form-label-group']"
                    >
                      <input
                        type="text"
                        maxlength="12"
                        class="form-control"
                        v-model="twh.drivername"
                        :placeholder="$t('message.twh.drivertype')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_drivertype"
                      />
                      <label
                        for="twh_drivertype"
                        class="form-label-group-label shorter"
                        >{{ $t("message.twh.drivertype") }}</label
                      >
                    </span>
                  </div>
                  <div class="col-md-6">
                    <span
                      :class="['bmd-form-group mb-2 d-block form-label-group']"
                    >
                      <input
                        type="text"
                        maxlength="76"
                        class="form-control"
                        v-model="twh.drivername"
                        :placeholder="$t('message.twh.drivername')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_drivername"
                      />
                      <label
                        for="twh_drivername"
                        class="form-label-group-label shorter"
                        >{{ $t("message.twh.drivername") }}</label
                      >
                    </span>
                  </div>
                  <div class="col-md-6">
                    <span
                      :class="['bmd-form-group mb-2 d-block form-label-group']"
                    >
                      <input
                        type="text"
                        maxlength="50"
                        class="form-control"
                        v-model="twh.drivername"
                        :placeholder="$t('message.twh.driverdocname')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_driverdocname"
                      />
                      <label
                        for="twh_driverdocname"
                        class="form-label-group-label shorter"
                        >{{ $t("message.twh.driverdocname") }}</label
                      >
                    </span>
                  </div>
                  <div class="col-md-6">
                    <span
                      :class="['bmd-form-group mb-2 d-block form-label-group']"
                    >
                      <input
                        type="text"
                        maxlength="20"
                        class="form-control"
                        v-model="twh.driverpasspnum"
                        :placeholder="$t('message.twh.driverpasspnum')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_driverpasspnum"
                      />
                      <label
                        for="twh_driverpasspnum"
                        class="form-label-group-label shorter"
                        >{{ $t("message.twh.driverpasspnum") }}</label
                      >
                    </span>
                  </div>
                  <div class="col-md-6">
                    <span
                      :class="[
                        'bmd-form-group mb-2 d-block form-label-group shorter',
                      ]"
                    >
                      <datepicker
                        value-type="YYYY-MM-DD"
                        format="DD.MM.YYYY"
                        @focus="twh.driverpasspdate = ' '"
                        @blur="
                          twh.driverpasspdate == ' '
                            ? (twh.driverpasspdate = '')
                            : (twh.driverpasspdate = twh.driverpasspdate)
                        "
                        inputClass="form-control"
                        v-model="twh.driverpasspdate"
                        :placeholder="$t('message.twh.driverpasspdate')"
                        :inputAttr="{ id: 'twh_driverpasspdate' }"
                      />
                      <label
                        for="twh_driverpasspdate"
                        class="form-label-group-label shorter"
                        :class="
                          twh.driverpasspdate != '' &&
                          twh.driverpasspdate != null
                            ? 'topped'
                            : ''
                        "
                        >{{ $t("message.twh.driverpasspdate") }}</label
                      >
                    </span>
                  </div>
                  <div class="col-md-6">
                    <span
                      :class="['bmd-form-group mb-2 d-block form-label-group']"
                    >
                      <input
                        type="text"
                        maxlength="80"
                        class="form-control"
                        v-model="twh.driverpasspplace"
                        :placeholder="$t('message.twh.driverpasspplace')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_driverpasspplace"
                      />
                      <label
                        for="twh_driverpasspplace"
                        class="form-label-group-label shorter"
                        >{{ $t("message.twh.driverpasspplace") }}</label
                      >
                    </span>
                  </div>
                </div>
                <hr />
                <h5>{{ $t("message.twh.carrier") }}</h5>
                <div class="row">
                  <div class="col-md-6">
                    <span
                      :class="['bmd-form-group mb-2 d-block form-label-group']"
                    >
                      <input
                        type="text"
                        maxlength="20"
                        class="form-control"
                        v-model="twh.carrierrnn"
                        :placeholder="$t('message.twh.carrierrnn')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_carrierrnn"
                      />
                      <label
                        for="twh_carrierrnn"
                        class="form-label-group-label shorter"
                        >{{ $t("message.twh.carrierrnn") }}</label
                      >
                    </span>
                  </div>
                  <div class="col-md-6">
                    <span
                      :class="['bmd-form-group mb-2 d-block form-label-group']"
                    >
                      <input
                        type="text"
                        maxlength="255"
                        class="form-control"
                        v-model="twh.carriername"
                        :placeholder="$t('message.twh.carriername2')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_carriername"
                      />
                      <label
                        for="twh_carriername"
                        class="form-label-group-label shorter"
                        >{{ $t("message.twh.carriername2") }}</label
                      >
                    </span>
                  </div>
                  <div class="col-md-12">
                    <span
                      :class="['bmd-form-group mb-2 d-block form-label-group']"
                    >
                      <input
                        type="text"
                        maxlength="76"
                        class="form-control"
                        v-model="twh.carrieraddress"
                        :placeholder="$t('message.twh.carrieraddress')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_carrieraddress"
                      />
                      <label
                        for="twh_carrieraddress"
                        class="form-label-group-label shorter"
                        >{{ $t("message.twh.carrieraddress") }}</label
                      >
                    </span>
                  </div>
                  <div class="col-md-6">
                    <span
                      :class="['bmd-form-group mb-2 d-block form-label-group']"
                    >
                      <input
                        type="text"
                        maxlength="76"
                        class="form-control"
                        v-model="twh.carrierstamp1"
                        :placeholder="$t('message.twh.carrierstamp1')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_carrierstamp1"
                      />
                      <label
                        for="twh_carrierstamp1"
                        class="form-label-group-label shorter"
                        >{{ $t("message.twh.carrierstamp1") }}</label
                      >
                    </span>
                  </div>
                  <div class="col-md-6">
                    <span
                      :class="['bmd-form-group mb-2 d-block form-label-group']"
                    >
                      <input
                        type="text"
                        maxlength="76"
                        class="form-control"
                        v-model="twh.carrierstamp2"
                        :placeholder="$t('message.twh.carrierstamp2')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_carrierstamp2"
                      />
                      <label
                        for="twh_carrierstamp2"
                        class="form-label-group-label shorter"
                        >{{ $t("message.twh.carrierstamp2") }}</label
                      >
                    </span>
                  </div>
                </div>
                <hr />
                <h5>{{ $t("message.twh.registration_twh") }}</h5>
                <div class="row">
                  <div class="col-md-6">
                    <span
                      :class="['bmd-form-group mb-2 d-block form-label-group']"
                    >
                      <datepicker
                        value-type="YYYY-MM-DDThh:mm:ss"
                        type="datetime"
                        format="DD.MM.YYYY hh:mm:ss"
                        @focus="twh.placedate = ' '"
                        @blur="
                          twh.placedate == ' '
                            ? (twh.placedate = '')
                            : (twh.placedate = twh.placedate)
                        "
                        inputClass="form-control"
                        v-model="twh.placedate"
                        :placeholder="$t('message.twh.placedate')"
                        :inputAttr="{ id: 'twh_placedate' }"
                      />
                      <label
                        for="twh_placedate"
                        class="form-label-group-label shorter"
                        :class="
                          twh.placedate != '' && twh.placedate != null
                            ? 'topped'
                            : ''
                        "
                        >{{ $t("message.twh.placedate") }}</label
                      >
                    </span>
                  </div>
                  <div class="col-md-6">
                    <span
                      :class="['bmd-form-group mb-2 d-block form-label-group']"
                    >
                      <input
                        type="text"
                        maxlength="76"
                        class="form-control"
                        v-model="twh.specialist"
                        :placeholder="$t('message.twh.specialist')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_specialist"
                      />
                      <label
                        for="twh_specialist"
                        class="form-label-group-label shorter"
                        >{{ $t("message.twh.specialist") }}</label
                      >
                    </span>
                  </div>
                  <div class="col-md-6">
                    <span
                      :class="['bmd-form-group mb-2 d-block form-label-group']"
                    >
                      <input
                        type="text"
                        maxlength="30"
                        class="form-control"
                        v-model="twh.cbxnum"
                        :placeholder="$t('message.twh.cbxnum2')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_cbxnum"
                      />
                      <label
                        for="twh_cbxnum"
                        class="form-label-group-label shorter"
                        >{{ $t("message.twh.cbxnum2") }}</label
                      >
                    </span>
                  </div>
                  <div class="col-md-6">
                    <span
                      :class="['bmd-form-group mb-2 d-block form-label-group']"
                    >
                      <input
                        type="text"
                        maxlength="30"
                        class="form-control"
                        v-model="twh.placename"
                        :placeholder="$t('message.twh.placename')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_placename"
                      />
                      <label
                        for="twh_placename"
                        class="form-label-group-label shorter"
                        >{{ $t("message.twh.placename") }}</label
                      >
                    </span>
                  </div>
                </div>
                <hr />
                <h5>{{ $t("message.twh.check_results") }}</h5>
                <div class="row">
                  <div class="col-md-6">
                    <span
                      :class="['bmd-form-group mb-2 d-flex align-items-center']"
                    >
                      <input
                        type="checkbox"
                        maxlength="30"
                        class="mr-2"
                        v-model="twh.damage"
                        :placeholder="$t('message.twh.damage')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_damage"
                      />
                      <label
                        for="twh_damage"
                        class="form-label-group-label mb-0 shorter"
                        >{{ $t("message.twh.damage") }}</label
                      >
                    </span>
                  </div>
                  <div class="col-md-6">
                    <span
                      :class="['bmd-form-group mb-2 d-block form-label-group']"
                    >
                      <input
                        type="text"
                        maxlength="200"
                        class="form-control"
                        v-model="twh.damcomment"
                        :placeholder="$t('message.twh.damcomment')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_damcomment"
                      />
                      <label
                        for="twh_damcomment"
                        class="form-label-group-label shorter"
                        >{{ $t("message.twh.damcomment") }}</label
                      >
                    </span>
                  </div>
                  <div class="col-md-6">
                    <span
                      :class="['bmd-form-group mb-2 d-flex align-items-center']"
                    >
                      <input
                        type="checkbox"
                        maxlength="30"
                        class="mr-2"
                        v-model="twh.breachiden"
                        :placeholder="$t('message.twh.breachiden')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_breachiden"
                      />
                      <label
                        for="twh_breachiden"
                        class="form-label-group-label mb-0 shorter"
                        >{{ $t("message.twh.breachiden") }}</label
                      >
                    </span>
                  </div>
                  <div class="col-md-3">
                    <span
                      :class="['bmd-form-group mb-1 d-block form-label-group']"
                    >
                      <label
                        for="twh_bi_amount"
                        :class="[
                          'form-label-group-label shorter',
                          twh.bi_amount != '' ? 'high' : '',
                        ]"
                        >{{ $t("message.twh.bi_amount") }}</label
                      >
                      <cleave
                        id="twh_bi_amount"
                        v-model="twh.bi_amount"
                        :options="cleave"
                        class="form-control"
                        :placeholder="$t('message.twh.bi_amount')"
                        autocomplete="off"
                        style="cursor: auto"
                      ></cleave>
                    </span>
                  </div>
                  <div class="col-md-3">
                    <span
                      :class="['bmd-form-group mb-2 d-block form-label-group']"
                    >
                      <input
                        type="text"
                        maxlength="100"
                        class="form-control"
                        v-model="twh.bi_num"
                        :placeholder="$t('message.twh.bi_num')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_bi_num"
                      />
                      <label
                        for="twh_bi_num"
                        class="form-label-group-label shorter"
                        >{{ $t("message.twh.bi_num") }}</label
                      >
                    </span>
                  </div>

                  <div class="col-md-6">
                    <span
                      :class="['bmd-form-group mb-2 d-flex align-items-center']"
                    >
                      <input
                        type="checkbox"
                        maxlength="30"
                        class="mr-2"
                        v-model="twh.removeiden"
                        :placeholder="$t('message.twh.removeiden')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_removeiden"
                      />
                      <label
                        for="twh_removeiden"
                        class="form-label-group-label mb-0 shorter"
                        >{{ $t("message.twh.removeiden") }}</label
                      >
                    </span>
                  </div>
                  <div class="col-md-3">
                    <span
                      :class="['bmd-form-group mb-1 d-block form-label-group']"
                    >
                      <label
                        for="twh_ri_amount"
                        :class="[
                          'form-label-group-label shorter',
                          twh.ri_amount != '' ? 'high' : '',
                        ]"
                        >{{ $t("message.twh.ri_amount") }}</label
                      >
                      <cleave
                        id="twh_ri_amount"
                        v-model="twh.ri_amount"
                        :options="cleave"
                        class="form-control"
                        :placeholder="$t('message.twh.ri_amount')"
                        autocomplete="off"
                        style="cursor: auto"
                      ></cleave>
                    </span>
                  </div>
                  <div class="col-md-3">
                    <span
                      :class="['bmd-form-group mb-2 d-block form-label-group']"
                    >
                      <input
                        type="text"
                        maxlength="100"
                        class="form-control"
                        v-model="twh.ri_num"
                        :placeholder="$t('message.twh.ri_num')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_ri_num"
                      />
                      <label
                        for="twh_ri_num"
                        class="form-label-group-label shorter"
                        >{{ $t("message.twh.ri_num") }}</label
                      >
                    </span>
                  </div>

                  <div class="col-md-6">
                    <span
                      :class="['bmd-form-group mb-2 d-flex align-items-center']"
                    >
                      <input
                        type="checkbox"
                        maxlength="30"
                        class="mr-2"
                        v-model="twh.imposiden"
                        :placeholder="$t('message.twh.imposiden')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_imposiden"
                      />
                      <label
                        for="twh_imposiden"
                        class="form-label-group-label mb-0 shorter"
                        >{{ $t("message.twh.imposiden") }}</label
                      >
                    </span>
                  </div>
                  <div class="col-md-3">
                    <span
                      :class="['bmd-form-group mb-1 d-block form-label-group']"
                    >
                      <label
                        for="twh_ii_amount"
                        :class="[
                          'form-label-group-label shorter',
                          twh.ii_amount != '' ? 'high' : '',
                        ]"
                        >{{ $t("message.twh.ii_amount") }}</label
                      >
                      <cleave
                        id="twh_ii_amount"
                        v-model="twh.ii_amount"
                        :options="cleave"
                        class="form-control"
                        :placeholder="$t('message.twh.ii_amount')"
                        autocomplete="off"
                        style="cursor: auto"
                      ></cleave>
                    </span>
                  </div>
                  <div class="col-md-3">
                    <span
                      :class="['bmd-form-group mb-2 d-block form-label-group']"
                    >
                      <input
                        type="text"
                        maxlength="100"
                        class="form-control"
                        v-model="twh.ii_num"
                        :placeholder="$t('message.twh.ii_num')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_ii_num"
                      />
                      <label
                        for="twh_ii_num"
                        class="form-label-group-label shorter"
                        >{{ $t("message.twh.ii_num") }}</label
                      >
                    </span>
                  </div>
                </div>
                <hr />
                <h5>{{ $t("message.twh.registration_pto") }}</h5>
                <div class="row">
                  <div class="col-md-6">
                    <span
                      :class="['bmd-form-group mb-2 d-block form-label-group']"
                    >
                      <input
                        type="text"
                        maxlength="10"
                        class="form-control"
                        v-model="twh.dcodepto"
                        :placeholder="$t('message.twh.dcodepto')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_dcodepto"
                      />
                      <label
                        for="twh_dcodepto"
                        class="form-label-group-label shorter"
                        >{{ $t("message.twh.dcodepto") }}</label
                      >
                    </span>
                  </div>
                  <div class="col-md-6">
                    <span
                      :class="['bmd-form-group mb-2 d-block form-label-group']"
                    >
                      <input
                        type="text"
                        maxlength="50"
                        class="form-control"
                        v-model="twh.namepto"
                        :placeholder="$t('message.twh.namepto')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_namepto"
                      />
                      <label
                        for="twh_namepto"
                        class="form-label-group-label shorter"
                        >{{ $t("message.twh.namepto") }}</label
                      >
                    </span>
                  </div>
                  <div class="col-md-6">
                    <span
                      :class="[
                        'bmd-form-group mb-2 d-block form-label-group shorter',
                      ]"
                    >
                      <datepicker
                        value-type="YYYY-MM-DDThh:mm:ss"
                        type="datetime"
                        format="DD.MM.YYYY hh:mm:ss"
                        @focus="twh.noticedate = ' '"
                        @blur="
                          twh.noticedate == ' '
                            ? (twh.noticedate = '')
                            : (twh.noticedate = twh.noticedate)
                        "
                        inputClass="form-control"
                        v-model="twh.noticedate"
                        :placeholder="$t('message.twh.noticedate')"
                        :inputAttr="{ id: 'twh_noticedate' }"
                      />
                      <label
                        for="twh_noticedate"
                        class="form-label-group-label shorter"
                        :class="
                          twh.noticedate != '' && twh.noticedate != null
                            ? 'topped'
                            : ''
                        "
                        >{{ $t("message.twh.noticedate") }}</label
                      >
                    </span>
                  </div>
                  <div class="col-md-6">
                    <span
                      :class="['bmd-form-group mb-2 d-block form-label-group']"
                    >
                      <input
                        type="text"
                        maxlength="20"
                        class="form-control"
                        v-model="twh.regnum"
                        :placeholder="$t('message.twh.regnum')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_regnum"
                      />
                      <label
                        for="twh_regnum"
                        class="form-label-group-label shorter"
                        >{{ $t("message.twh.regnum") }}</label
                      >
                    </span>
                  </div>
                  <div class="col-md-6">
                    <span
                      :class="['bmd-form-group mb-2 d-block form-label-group']"
                    >
                      <input
                        type="text"
                        maxlength="76"
                        class="form-control"
                        v-model="twh.custofficername"
                        :placeholder="$t('message.twh.custofficername')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_custofficername"
                      />
                      <label
                        for="twh_custofficername"
                        class="form-label-group-label shorter"
                        >{{ $t("message.twh.custofficername") }}</label
                      >
                    </span>
                  </div>
                  <div class="col-md-6">
                    <span
                      :class="['bmd-form-group mb-2 d-block form-label-group']"
                    >
                      <input
                        type="text"
                        maxlength="76"
                        class="form-control"
                        v-model="twh.custofficerstampnum"
                        :placeholder="$t('message.twh.custofficerstampnum')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_custofficerstampnum"
                      />
                      <label
                        for="twh_custofficerstampnum"
                        class="form-label-group-label shorter"
                        >{{ $t("message.twh.custofficerstampnum") }}</label
                      >
                    </span>
                  </div>
                  <div class="col-md-12">
                    <span
                      :class="['bmd-form-group mb-2 d-block form-label-group']"
                    >
                      <input
                        type="text"
                        maxlength="255"
                        class="form-control"
                        v-model="twh.custmark"
                        :placeholder="$t('message.twh.custmark')"
                        autocomplete="off"
                        style="cursor: auto"
                        id="twh_custmark"
                      />
                      <label
                        for="twh_custmark"
                        class="form-label-group-label shorter"
                        >{{ $t("message.twh.custmark") }}</label
                      >
                    </span>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <h4>{{ $t("message.twh.custdocs") }}</h4>
                    <div class="table overflow-auto">
                      <b-table
                        :fields="custdocs_fields"
                        :items="twh.docnotificationcustdocs"
                      >
                        <template v-slot:cell(doctype)="data">
                          {{ data.value.display_text }}
                        </template>
                        <template v-slot:cell(actions)="data">
                          <button
                            class="btn btn-link p-0"
                            @click="edit_additional_row('custdocs', data.index)"
                            :title="$t('message.edit')"
                          >
                            <i class="fa fa-edit"></i>
                          </button>
                          <button
                            class="btn btn-link p-0 text-danger"
                            @click="
                              delete_additional_row('custdocs', data.index)
                            "
                            :title="$t('message.delete')"
                          >
                            <i class="fa fa-trash"></i>
                          </button>
                        </template>
                      </b-table>
                    </div>
                    <button
                      @click="add_additional_row('custdocs')"
                      class="btn btn-success btn-sm btn-round btn-pills"
                    >
                      {{ $t("message.add") }}
                    </button>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-12">
                    <h4>{{ $t("message.twh.docs") }}</h4>
                    <div class="table overflow-auto">
                      <b-table
                        :fields="docs_fields"
                        :items="twh.docnotificationdocs"
                      >
                        <template v-slot:cell(doctype)="data">
                          {{ data.value.display_text }}
                        </template>
                        <template v-slot:cell(doccurrencycode)="data">
                          {{ data.value.display_text }}
                        </template>
                        <template v-slot:cell(actions)="data">
                          <button
                            class="btn btn-link p-0"
                            @click="edit_additional_row('docs', data.index)"
                            :title="$t('message.edit')"
                          >
                            <i class="fa fa-edit"></i>
                          </button>
                          <button
                            class="btn btn-link p-0 text-danger"
                            @click="delete_additional_row('docs', data.index)"
                            :title="$t('message.delete')"
                          >
                            <i class="fa fa-trash"></i>
                          </button>
                        </template>
                      </b-table>
                    </div>
                    <button
                      @click="add_additional_row('docs')"
                      class="btn btn-success btn-sm btn-round btn-pills"
                    >
                      {{ $t("message.add") }}
                    </button>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-12">
                    <h4>{{ $t("message.twh.permdocs") }}</h4>
                    <div class="table overflow-auto">
                      <b-table
                        :fields="permdocs_fields"
                        :items="twh.docnotificationpermdocs"
                      >
                        <template v-slot:cell(doctype)="data">
                          {{ data.value.display_text }}
                        </template>
                        <template v-slot:cell(doccurrencycode)="data">
                          {{ data.value.display_text }}
                        </template>
                        <template v-slot:cell(actions)="data">
                          <button
                            class="btn btn-link p-0"
                            @click="edit_additional_row('permdocs', data.index)"
                            :title="$t('message.edit')"
                          >
                            <i class="fa fa-edit"></i>
                          </button>
                          <button
                            class="btn btn-link p-0 text-danger"
                            @click="
                              delete_additional_row('permdocs', data.index)
                            "
                            :title="$t('message.delete')"
                          >
                            <i class="fa fa-trash"></i>
                          </button>
                        </template>
                      </b-table>
                    </div>
                    <button
                      @click="add_additional_row('permdocs')"
                      class="btn btn-success btn-sm btn-round btn-pills"
                    >
                      {{ $t("message.add") }}
                    </button>
                  </div>
                </div>
                <div class="row mt-4 mb-4">
                  <div class="col-12">
                    <h4>{{ $t("message.twh.recipients") }}</h4>
                    <div class="table overflow-auto">
                      <b-table
                        :fields="recipients_fields"
                        :items="twh.docnotificationrecipients"
                      >
                        <template v-slot:cell(actions)="data">
                          <button
                            class="btn btn-link p-0"
                            @click="
                              edit_additional_row('recipients', data.index)
                            "
                            :title="$t('message.edit')"
                          >
                            <i class="fa fa-edit"></i>
                          </button>
                          <button
                            class="btn btn-link p-0 text-danger"
                            @click="
                              delete_additional_row('recipients', data.index)
                            "
                            :title="$t('message.delete')"
                          >
                            <i class="fa fa-trash"></i>
                          </button>
                        </template>
                      </b-table>
                    </div>
                    <button
                      @click="add_additional_row('recipients')"
                      class="btn btn-success btn-sm btn-round btn-pills"
                    >
                      {{ $t("message.add") }}
                    </button>
                  </div>
                </div>

                <div class="row mt-5">
                  <div class="col-12">
                    <button class="btn btn-success" @click="save">
                      {{ $t("message.save") }}
                    </button>
                  </div>
                </div>

                <b-modal
                  id="modal-add-custdocs"
                  size="lg"
                  centered
                  :hide-footer="true"
                  :title="$t('message.add') + ' ' + $t('message.twh.custdocs')"
                >
                  <div class="row">
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-1 d-block form-label-group',
                        ]"
                      >
                        <label
                          for="custdocs_recordid"
                          :class="[
                            'form-label-group-label shorter',
                            custdocs_current.recordid != '' ? 'high' : '',
                          ]"
                          >{{ $t("message.twh.recordid") }}</label
                        >
                        <cleave
                          id="custdocs_recordid"
                          v-model="custdocs_current.recordid"
                          :options="cleave"
                          class="form-control"
                          :placeholder="$t('message.twh.recordid')"
                          autocomplete="off"
                          style="cursor: auto"
                        ></cleave>
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-1 d-block form-label-group',
                        ]"
                      >
                        <label
                          for="custdocs_linenum"
                          :class="[
                            'form-label-group-label shorter',
                            custdocs_current.linenum != '' ? 'high' : '',
                          ]"
                          >{{ $t("message.twh.linenum") }}</label
                        >
                        <cleave
                          id="custdocs_linenum"
                          v-model="custdocs_current.linenum"
                          :options="cleave"
                          class="form-control"
                          :placeholder="$t('message.twh.linenum')"
                          autocomplete="off"
                          style="cursor: auto"
                        ></cleave>
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 mt-2 d-block form-label-group ',
                          focused.doctype == true ? 'focused' : '',
                        ]"
                      >
                        <v-select-popup
                          type="doc_type"
                          :placeholder="$t('message.twh.doctype')"
                          v-model="custdocs_current.doctype"
                        />
                        <!-- <v-select id="custdocs_doctype" :options="twh_doctypes" label="display_text" :class="['form-control', typeof custdocs_current.doctype !== 'undefined' && custdocs_current.doctype.value!==''?'vs--selected':'']" @search="fetchDoctypes"  v-model="custdocs_current.doctype" :placeholder="$t('message.twh.doctype')" @focus="focused.doctype=true" @blur="focused.doctype=false">
                                                </v-select>	
                                                <label for="custdocs_doctype" class="form-label-group-label shorter">{{$t('message.twh.doctype')}}</label> -->
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group',
                        ]"
                      >
                        <input
                          type="text"
                          class="form-control"
                          v-model="custdocs_current.docnum"
                          :placeholder="$t('message.twh.docnum')"
                          autocomplete="off"
                          style="cursor: auto"
                          id="custdocs_docnum"
                        />
                        <label
                          for="custdocs_docnum"
                          class="form-label-group-label shorter"
                          >{{ $t("message.twh.docnum") }}</label
                        >
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group shorter',
                        ]"
                      >
                        <datepicker
                          value-type="YYYY-MM-DD"
                          format="DD.MM.YYYY"
                          @focus="custdocs_current.docdate = ' '"
                          @blur="
                            custdocs_current.docdate == ' '
                              ? (custdocs_current.docdate = '')
                              : (custdocs_current.docdate =
                                  custdocs_current.docdate)
                          "
                          inputClass="form-control"
                          v-model="custdocs_current.docdate"
                          :placeholder="$t('message.twh.docdate')"
                          :inputAttr="{ id: 'twh_docdate' }"
                        />
                        <label
                          for="custdocs_docdate"
                          class="form-label-group-label shorter"
                          :class="
                            custdocs_current.docdate != '' &&
                            custdocs_current.docdate != null
                              ? 'topped'
                              : ''
                          "
                          >{{ $t("message.twh.docdate") }}</label
                        >
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group',
                        ]"
                      >
                        <input
                          type="text"
                          class="form-control"
                          v-model="custdocs_current.addpermfirm"
                          :placeholder="$t('message.twh.addpermfirm')"
                          autocomplete="off"
                          style="cursor: auto"
                          id="custdocs_addpermfirm"
                        />
                        <label
                          for="custdocs_addpermfirm"
                          class="form-label-group-label shorter"
                          >{{ $t("message.twh.addpermfirm") }}</label
                        >
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group',
                        ]"
                      >
                        <input
                          type="text"
                          class="form-control"
                          v-model="custdocs_current.custofficerstampnum"
                          :placeholder="$t('message.twh.custofficerstampnum')"
                          autocomplete="off"
                          style="cursor: auto"
                          id="custdocs_custofficerstampnum"
                        />
                        <label
                          for="custdocs_custofficerstampnum"
                          class="form-label-group-label shorter"
                          >{{ $t("message.twh.custofficerstampnum") }}</label
                        >
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group',
                        ]"
                      >
                        <input
                          type="text"
                          class="form-control"
                          v-model="custdocs_current.custofficername"
                          :placeholder="$t('message.twh.custofficername')"
                          autocomplete="off"
                          style="cursor: auto"
                          id="custdocs_custofficername"
                        />
                        <label
                          for="custdocs_custofficername"
                          class="form-label-group-label shorter"
                          >{{ $t("message.twh.custofficername") }}</label
                        >
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-1 d-block form-label-group',
                        ]"
                      >
                        <label
                          for="custdocs_ny"
                          :class="[
                            'form-label-group-label shorter',
                            custdocs_current.ny != '' ? 'high' : '',
                          ]"
                          >{{ $t("message.twh.ny") }}</label
                        >
                        <cleave
                          id="custdocs_ny"
                          v-model="custdocs_current.ny"
                          :options="cleave"
                          class="form-control"
                          :placeholder="$t('message.twh.ny')"
                          autocomplete="off"
                          style="cursor: auto"
                        ></cleave>
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-1 d-block form-label-group',
                        ]"
                      >
                        <label
                          for="custdocs_nj"
                          :class="[
                            'form-label-group-label shorter',
                            custdocs_current.nj != '' ? 'high' : '',
                          ]"
                          >{{ $t("message.twh.nj") }}</label
                        >
                        <cleave
                          id="custdocs_nj"
                          v-model="custdocs_current.nj"
                          :options="cleave"
                          class="form-control"
                          :placeholder="$t('message.twh.nj')"
                          autocomplete="off"
                          style="cursor: auto"
                        ></cleave>
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-1 d-block form-label-group',
                        ]"
                      >
                        <label
                          for="custdocs_nn"
                          :class="[
                            'form-label-group-label shorter',
                            custdocs_current.nn != '' ? 'high' : '',
                          ]"
                          >{{ $t("message.twh.nn") }}</label
                        >
                        <cleave
                          id="custdocs_nn"
                          v-model="custdocs_current.nn"
                          :options="cleave"
                          class="form-control"
                          :placeholder="$t('message.twh.nn')"
                          autocomplete="off"
                          style="cursor: auto"
                        ></cleave>
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group',
                        ]"
                      >
                        <input
                          type="text"
                          class="form-control"
                          v-model="custdocs_current.docdkd"
                          :placeholder="$t('message.twh.docdkd')"
                          autocomplete="off"
                          style="cursor: auto"
                          id="custdocs_docdkd"
                        />
                        <label
                          for="custdocs_docdkd"
                          class="form-label-group-label shorter"
                          >{{ $t("message.twh.docdkd") }}</label
                        >
                      </span>
                    </div>
                  </div>
                  <button
                    @click="create_new_additional_row('custdocs')"
                    class="btn btn-success"
                  >
                    {{ $t("message.add") }}
                  </button>
                </b-modal>
                <b-modal
                  id="modal-edit-custdocs"
                  size="lg"
                  centered
                  :hide-footer="true"
                  :title="$t('message.edit') + ' ' + $t('message.twh.custdocs')"
                >
                  <div class="row">
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-1 d-block form-label-group',
                        ]"
                      >
                        <label
                          for="custdocs_recordid"
                          :class="[
                            'form-label-group-label shorter',
                            custdocs_current.recordid != '' ? 'high' : '',
                          ]"
                          >{{ $t("message.twh.recordid") }}</label
                        >
                        <cleave
                          id="custdocs_recordid"
                          v-model="custdocs_current.recordid"
                          :options="cleave"
                          class="form-control"
                          :placeholder="$t('message.twh.recordid')"
                          autocomplete="off"
                          style="cursor: auto"
                        ></cleave>
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-1 d-block form-label-group',
                        ]"
                      >
                        <label
                          for="custdocs_linenum"
                          :class="[
                            'form-label-group-label shorter',
                            custdocs_current.linenum != '' ? 'high' : '',
                          ]"
                          >{{ $t("message.twh.linenum") }}</label
                        >
                        <cleave
                          id="custdocs_linenum"
                          v-model="custdocs_current.linenum"
                          :options="cleave"
                          class="form-control"
                          :placeholder="$t('message.twh.linenum')"
                          autocomplete="off"
                          style="cursor: auto"
                        ></cleave>
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 mt-2 d-block form-label-group ',
                          focused.doctype == true ? 'focused' : '',
                        ]"
                      >
                        <v-select-popup
                          type="doc_type"
                          :placeholder="$t('message.twh.doctype')"
                          v-model="custdocs_current.doctype"
                        />
                        <!-- <v-select id="custdocs_doctype" :options="twh_doctypes" label="display_text" :class="['form-control', typeof custdocs_current.doctype !== 'undefined' && custdocs_current.doctype.value!==''?'vs--selected':'']" @search="fetchDoctypes"  v-model="custdocs_current.doctype" :placeholder="$t('message.twh.doctype')" @focus="focused.doctype=true" @blur="focused.doctype=false">
                                                </v-select>	
                                                <label for="custdocs_doctype" class="form-label-group-label shorter">{{$t('message.twh.doctype')}}</label> -->
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group',
                        ]"
                      >
                        <input
                          type="text"
                          class="form-control"
                          v-model="custdocs_current.docnum"
                          :placeholder="$t('message.twh.docnum')"
                          autocomplete="off"
                          style="cursor: auto"
                          id="custdocs_docnum"
                        />
                        <label
                          for="custdocs_docnum"
                          class="form-label-group-label shorter"
                          >{{ $t("message.twh.docnum") }}</label
                        >
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group shorter',
                        ]"
                      >
                        <datepicker
                          value-type="YYYY-MM-DD"
                          format="DD.MM.YYYY"
                          @focus="custdocs_current.docdate = ' '"
                          @blur="
                            custdocs_current.docdate == ' '
                              ? (custdocs_current.docdate = '')
                              : (custdocs_current.docdate =
                                  custdocs_current.docdate)
                          "
                          inputClass="form-control"
                          v-model="custdocs_current.docdate"
                          :placeholder="$t('message.twh.docdate')"
                          :inputAttr="{ id: 'twh_docdate' }"
                        />
                        <label
                          for="custdocs_docdate"
                          class="form-label-group-label shorter"
                          :class="
                            custdocs_current.docdate != '' &&
                            custdocs_current.docdate != null
                              ? 'topped'
                              : ''
                          "
                          >{{ $t("message.twh.docdate") }}</label
                        >
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group',
                        ]"
                      >
                        <input
                          type="text"
                          class="form-control"
                          v-model="custdocs_current.addpermfirm"
                          :placeholder="$t('message.twh.addpermfirm')"
                          autocomplete="off"
                          style="cursor: auto"
                          id="custdocs_addpermfirm"
                        />
                        <label
                          for="custdocs_addpermfirm"
                          class="form-label-group-label shorter"
                          >{{ $t("message.twh.addpermfirm") }}</label
                        >
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group',
                        ]"
                      >
                        <input
                          type="text"
                          class="form-control"
                          v-model="custdocs_current.custofficerstampnum"
                          :placeholder="$t('message.twh.custofficerstampnum')"
                          autocomplete="off"
                          style="cursor: auto"
                          id="custdocs_custofficerstampnum"
                        />
                        <label
                          for="custdocs_custofficerstampnum"
                          class="form-label-group-label shorter"
                          >{{ $t("message.twh.custofficerstampnum") }}</label
                        >
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group',
                        ]"
                      >
                        <input
                          type="text"
                          class="form-control"
                          v-model="custdocs_current.custofficername"
                          :placeholder="$t('message.twh.custofficername')"
                          autocomplete="off"
                          style="cursor: auto"
                          id="custdocs_custofficername"
                        />
                        <label
                          for="custdocs_custofficername"
                          class="form-label-group-label shorter"
                          >{{ $t("message.twh.custofficername") }}</label
                        >
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-1 d-block form-label-group',
                        ]"
                      >
                        <label
                          for="custdocs_ny"
                          :class="[
                            'form-label-group-label shorter',
                            custdocs_current.ny != '' ? 'high' : '',
                          ]"
                          >{{ $t("message.twh.ny") }}</label
                        >
                        <cleave
                          id="custdocs_ny"
                          v-model="custdocs_current.ny"
                          :options="cleave"
                          class="form-control"
                          :placeholder="$t('message.twh.ny')"
                          autocomplete="off"
                          style="cursor: auto"
                        ></cleave>
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-1 d-block form-label-group',
                        ]"
                      >
                        <label
                          for="custdocs_nj"
                          :class="[
                            'form-label-group-label shorter',
                            custdocs_current.nj != '' ? 'high' : '',
                          ]"
                          >{{ $t("message.twh.nj") }}</label
                        >
                        <cleave
                          id="custdocs_nj"
                          v-model="custdocs_current.nj"
                          :options="cleave"
                          class="form-control"
                          :placeholder="$t('message.twh.nj')"
                          autocomplete="off"
                          style="cursor: auto"
                        ></cleave>
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-1 d-block form-label-group',
                        ]"
                      >
                        <label
                          for="custdocs_nn"
                          :class="[
                            'form-label-group-label shorter',
                            custdocs_current.nn != '' ? 'high' : '',
                          ]"
                          >{{ $t("message.twh.nn") }}</label
                        >
                        <cleave
                          id="custdocs_nn"
                          v-model="custdocs_current.nn"
                          :options="cleave"
                          class="form-control"
                          :placeholder="$t('message.twh.nn')"
                          autocomplete="off"
                          style="cursor: auto"
                        ></cleave>
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group',
                        ]"
                      >
                        <input
                          type="text"
                          class="form-control"
                          v-model="custdocs_current.docdkd"
                          :placeholder="$t('message.twh.docdkd')"
                          autocomplete="off"
                          style="cursor: auto"
                          id="custdocs_docdkd"
                        />
                        <label
                          for="custdocs_docdkd"
                          class="form-label-group-label shorter"
                          >{{ $t("message.twh.docdkd") }}</label
                        >
                      </span>
                    </div>
                  </div>
                  <button
                    @click="save_change_additional_row('custdocs')"
                    class="btn btn-success"
                  >
                    {{ $t("message.save") }}
                  </button>
                </b-modal>

                <b-modal
                  id="modal-add-docs"
                  size="lg"
                  centered
                  :hide-footer="true"
                  :title="$t('message.add') + ' ' + $t('message.twh.docs')"
                >
                  <div class="row">
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-1 d-block form-label-group',
                        ]"
                      >
                        <label
                          for="docs_recordid"
                          :class="[
                            'form-label-group-label shorter',
                            docs_current.recordid != '' ? 'high' : '',
                          ]"
                          >{{ $t("message.twh.recordid") }}</label
                        >
                        <cleave
                          id="docs_recordid"
                          v-model="docs_current.recordid"
                          :options="cleave"
                          class="form-control"
                          :placeholder="$t('message.twh.recordid')"
                          autocomplete="off"
                          style="cursor: auto"
                        ></cleave>
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-1 d-block form-label-group',
                        ]"
                      >
                        <label
                          for="docs_linenum"
                          :class="[
                            'form-label-group-label shorter',
                            docs_current.linenum != '' ? 'high' : '',
                          ]"
                          >{{ $t("message.twh.linenum") }}</label
                        >
                        <cleave
                          id="docs_linenum"
                          v-model="docs_current.linenum"
                          :options="cleave"
                          class="form-control"
                          :placeholder="$t('message.twh.linenum')"
                          autocomplete="off"
                          style="cursor: auto"
                        ></cleave>
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 mt-2 d-block form-label-group ',
                          focused.doctype == true ? 'focused' : '',
                        ]"
                      >
                        <v-select-popup
                          type="doc_type"
                          :placeholder="$t('message.twh.doctype')"
                          v-model="docs_current.doctype"
                        />

                        <!-- <v-select id="docs_doctype" :options="twh_doctypes" label="display_text" :class="['form-control', typeof docs_current.doctype !== 'undefined' && docs_current.doctype.value!==''?'vs--selected':'']" @search="fetchDoctypes"  v-model="docs_current.doctype" :placeholder="$t('message.twh.doctype')" @focus="focused.doctype=true" @blur="focused.doctype=false">
                                                </v-select>	
                                                <label for="docs_doctype" class="form-label-group-label shorter">{{$t('message.twh.doctype')}}</label> -->
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group',
                        ]"
                      >
                        <input
                          type="text"
                          class="form-control"
                          v-model="docs_current.docnum"
                          :placeholder="$t('message.twh.docnum')"
                          autocomplete="off"
                          style="cursor: auto"
                          id="docs_docnum"
                        />
                        <label
                          for="docs_docnum"
                          class="form-label-group-label shorter"
                          >{{ $t("message.twh.docnum") }}</label
                        >
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group shorter',
                        ]"
                      >
                        <datepicker
                          value-type="YYYY-MM-DD"
                          format="DD.MM.YYYY"
                          @focus="docs_current.docdate = ' '"
                          @blur="
                            docs_current.docdate == ' '
                              ? (docs_current.docdate = '')
                              : (docs_current.docdate = twh.docdate)
                          "
                          inputClass="form-control"
                          v-model="docs_current.docdate"
                          :placeholder="$t('message.twh.docdate')"
                          :inputAttr="{ id: 'twh_docdate' }"
                        />
                        <label
                          for="docs_docdate"
                          class="form-label-group-label shorter"
                          :class="
                            docs_current.docdate != '' &&
                            docs_current.docdate != null
                              ? 'topped'
                              : ''
                          "
                          >{{ $t("message.twh.docdate") }}</label
                        >
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group',
                        ]"
                      >
                        <input
                          type="text"
                          class="form-control"
                          v-model="docs_current.doccomment"
                          :placeholder="$t('message.twh.doccomment')"
                          autocomplete="off"
                          style="cursor: auto"
                          id="docs_doccomment"
                        />
                        <label
                          for="docs_doccomment"
                          class="form-label-group-label shorter"
                          >{{ $t("message.twh.doccomment") }}</label
                        >
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group',
                        ]"
                      >
                        <input
                          type="text"
                          class="form-control"
                          v-model="docs_current.docfirm"
                          :placeholder="$t('message.twh.docfirm')"
                          autocomplete="off"
                          style="cursor: auto"
                          id="docs_docfirm"
                        />
                        <label
                          for="docs_docfirm"
                          class="form-label-group-label shorter"
                          >{{ $t("message.twh.docfirm") }}</label
                        >
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-1 d-block form-label-group',
                        ]"
                      >
                        <label
                          for="docs_docnetto"
                          :class="[
                            'form-label-group-label shorter',
                            docs_current.docnetto != '' ? 'high' : '',
                          ]"
                          >{{ $t("message.twh.docnetto") }}</label
                        >
                        <cleave
                          id="docs_docnetto"
                          v-model="docs_current.docnetto"
                          :options="cleaveWeight"
                          class="form-control"
                          :placeholder="$t('message.twh.docnetto')"
                          autocomplete="off"
                          style="cursor: auto"
                        ></cleave>
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-1 d-block form-label-group',
                        ]"
                      >
                        <label
                          for="docs_docbrutto"
                          :class="[
                            'form-label-group-label shorter',
                            docs_current.docbrutto != '' ? 'high' : '',
                          ]"
                          >{{ $t("message.twh.docbrutto") }}</label
                        >
                        <cleave
                          id="docs_docbrutto"
                          v-model="docs_current.docbrutto"
                          :options="cleaveWeight"
                          class="form-control"
                          :placeholder="$t('message.twh.docbrutto')"
                          autocomplete="off"
                          style="cursor: auto"
                        ></cleave>
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 mt-2 d-block form-label-group ',
                          focused.doctype == true ? 'focused' : '',
                        ]"
                      >
                        <v-select-popup
                          type="currency"
                          :placeholder="$t('message.twh.doccurrencycode')"
                          v-model="docs_current.doccurrencycode"
                        />

                        <!-- <v-select id="docs_doccurrencycode" :options="currencies" label="display_text" :class="['form-control', typeof docs_current.doccurrencycode !== 'undefined' && docs_current.doccurrencycode.value!==''?'vs--selected':'']" @search="fetchCurrencies"  v-model="docs_current.doccurrencycode" :placeholder="$t('message.twh.doccurrencycode')" @focus="focused.doccurrencycode=true" @blur="focused.doccurrencycode=false">
                                                </v-select>	
                                                <label for="docs_doccurrencycode" class="form-label-group-label shorter">{{$t('message.twh.doccurrencycode')}}</label> -->
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-1 d-block form-label-group',
                        ]"
                      >
                        <label
                          for="docs_docprice"
                          :class="[
                            'form-label-group-label shorter',
                            docs_current.docprice != '' ? 'high' : '',
                          ]"
                          >{{ $t("message.twh.docprice") }}</label
                        >
                        <cleave
                          id="docs_docprice"
                          v-model="docs_current.docprice"
                          :options="cleaveWeight"
                          class="form-control"
                          :placeholder="$t('message.twh.docprice')"
                          autocomplete="off"
                          style="cursor: auto"
                        ></cleave>
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group',
                        ]"
                      >
                        <input
                          type="text"
                          class="form-control"
                          v-model="docs_current.sendername"
                          :placeholder="$t('message.twh.sendername')"
                          autocomplete="off"
                          style="cursor: auto"
                          id="docs_sendername"
                        />
                        <label
                          for="docs_sendername"
                          class="form-label-group-label shorter"
                          >{{ $t("message.twh.sendername") }}</label
                        >
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group shorter',
                        ]"
                      >
                        <datepicker
                          value-type="YYYY-MM-DD"
                          format="DD.MM.YYYY"
                          @focus="docs_current.docdatecreate = ' '"
                          @blur="
                            docs_current.docdatecreate == ' '
                              ? (docs_current.docdatecreate = '')
                              : (docs_current.docdatecreate =
                                  docs_current.docdatecreate)
                          "
                          inputClass="form-control"
                          v-model="docs_current.docdatecreate"
                          :placeholder="$t('message.twh.docdatecreate')"
                          :inputAttr="{ id: 'twh_docdatecreate' }"
                        />
                        <label
                          for="docs_docdatecreate"
                          class="form-label-group-label shorter"
                          :class="
                            docs_current.docdatecreate != '' &&
                            docs_current.docdatecreate != null
                              ? 'topped'
                              : ''
                          "
                          >{{ $t("message.twh.docdatecreate") }}</label
                        >
                      </span>
                    </div>
                  </div>
                  <button
                    @click="create_new_additional_row('docs')"
                    class="btn btn-success"
                  >
                    {{ $t("message.add") }}
                  </button>
                </b-modal>
                <b-modal
                  id="modal-edit-docs"
                  size="lg"
                  centered
                  :hide-footer="true"
                  :title="$t('message.edit') + ' ' + $t('message.twh.docs')"
                >
                  <div class="row">
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-1 d-block form-label-group',
                        ]"
                      >
                        <label
                          for="docs_recordid"
                          :class="[
                            'form-label-group-label shorter',
                            docs_current.recordid != '' ? 'high' : '',
                          ]"
                          >{{ $t("message.twh.recordid") }}</label
                        >
                        <cleave
                          id="docs_recordid"
                          v-model="docs_current.recordid"
                          :options="cleave"
                          class="form-control"
                          :placeholder="$t('message.twh.recordid')"
                          autocomplete="off"
                          style="cursor: auto"
                        ></cleave>
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-1 d-block form-label-group',
                        ]"
                      >
                        <label
                          for="docs_linenum"
                          :class="[
                            'form-label-group-label shorter',
                            docs_current.linenum != '' ? 'high' : '',
                          ]"
                          >{{ $t("message.twh.linenum") }}</label
                        >
                        <cleave
                          id="docs_linenum"
                          v-model="docs_current.linenum"
                          :options="cleave"
                          class="form-control"
                          :placeholder="$t('message.twh.linenum')"
                          autocomplete="off"
                          style="cursor: auto"
                        ></cleave>
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 mt-2 d-block form-label-group ',
                          focused.doctype == true ? 'focused' : '',
                        ]"
                      >
                        <v-select-popup
                          type="doc_type"
                          :placeholder="$t('message.twh.doctype')"
                          v-model="docs_current.doctype"
                        />

                        <!-- <v-select id="docs_doctype" :options="twh_doctypes" label="display_text" :class="['form-control', typeof docs_current.doctype !== 'undefined' && docs_current.doctype.value!==''?'vs--selected':'']" @search="fetchDoctypes"  v-model="docs_current.doctype" :placeholder="$t('message.twh.doctype')" @focus="focused.doctype=true" @blur="focused.doctype=false">
                                                </v-select>	
                                                <label for="docs_doctype" class="form-label-group-label shorter">{{$t('message.twh.doctype')}}</label> -->
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group',
                        ]"
                      >
                        <input
                          type="text"
                          class="form-control"
                          v-model="docs_current.docnum"
                          :placeholder="$t('message.twh.docnum')"
                          autocomplete="off"
                          style="cursor: auto"
                          id="docs_docnum"
                        />
                        <label
                          for="docs_docnum"
                          class="form-label-group-label shorter"
                          >{{ $t("message.twh.docnum") }}</label
                        >
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group shorter',
                        ]"
                      >
                        <datepicker
                          value-type="YYYY-MM-DD"
                          format="DD.MM.YYYY"
                          @focus="docs_current.docdate = ' '"
                          @blur="
                            docs_current.docdate == ' '
                              ? (docs_current.docdate = '')
                              : (docs_current.docdate = twh.docdate)
                          "
                          inputClass="form-control"
                          v-model="docs_current.docdate"
                          :placeholder="$t('message.twh.docdate')"
                          :inputAttr="{ id: 'twh_docdate' }"
                        />
                        <label
                          for="docs_docdate"
                          class="form-label-group-label shorter"
                          :class="
                            docs_current.docdate != '' &&
                            docs_current.docdate != null
                              ? 'topped'
                              : ''
                          "
                          >{{ $t("message.twh.docdate") }}</label
                        >
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group',
                        ]"
                      >
                        <input
                          type="text"
                          class="form-control"
                          v-model="docs_current.doccomment"
                          :placeholder="$t('message.twh.doccomment')"
                          autocomplete="off"
                          style="cursor: auto"
                          id="docs_doccomment"
                        />
                        <label
                          for="docs_doccomment"
                          class="form-label-group-label shorter"
                          >{{ $t("message.twh.doccomment") }}</label
                        >
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group',
                        ]"
                      >
                        <input
                          type="text"
                          class="form-control"
                          v-model="docs_current.docfirm"
                          :placeholder="$t('message.twh.docfirm')"
                          autocomplete="off"
                          style="cursor: auto"
                          id="docs_docfirm"
                        />
                        <label
                          for="docs_docfirm"
                          class="form-label-group-label shorter"
                          >{{ $t("message.twh.docfirm") }}</label
                        >
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-1 d-block form-label-group',
                        ]"
                      >
                        <label
                          for="docs_docnetto"
                          :class="[
                            'form-label-group-label shorter',
                            docs_current.docnetto != '' ? 'high' : '',
                          ]"
                          >{{ $t("message.twh.docnetto") }}</label
                        >
                        <cleave
                          id="docs_docnetto"
                          v-model="docs_current.docnetto"
                          :options="cleaveWeight"
                          class="form-control"
                          :placeholder="$t('message.twh.docnetto')"
                          autocomplete="off"
                          style="cursor: auto"
                        ></cleave>
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-1 d-block form-label-group',
                        ]"
                      >
                        <label
                          for="docs_docbrutto"
                          :class="[
                            'form-label-group-label shorter',
                            docs_current.docbrutto != '' ? 'high' : '',
                          ]"
                          >{{ $t("message.twh.docbrutto") }}</label
                        >
                        <cleave
                          id="docs_docbrutto"
                          v-model="docs_current.docbrutto"
                          :options="cleaveWeight"
                          class="form-control"
                          :placeholder="$t('message.twh.docbrutto')"
                          autocomplete="off"
                          style="cursor: auto"
                        ></cleave>
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 mt-2 d-block form-label-group ',
                          focused.doctype == true ? 'focused' : '',
                        ]"
                      >
                        <v-select-popup
                          type="currency"
                          :placeholder="$t('message.twh.doccurrencycode')"
                          v-model="docs_current.doccurrencycode"
                        />

                        <!-- <v-select id="docs_doccurrencycode" :options="currencies" label="display_text" :class="['form-control', typeof docs_current.doccurrencycode !== 'undefined' && docs_current.doccurrencycode.value!==''?'vs--selected':'']" @search="fetchCurrencies"  v-model="docs_current.doccurrencycode" :placeholder="$t('message.twh.doccurrencycode')" @focus="focused.doccurrencycode=true" @blur="focused.doccurrencycode=false">
                                                </v-select>	
                                                <label for="docs_doccurrencycode" class="form-label-group-label shorter">{{$t('message.twh.doccurrencycode')}}</label> -->
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-1 d-block form-label-group',
                        ]"
                      >
                        <label
                          for="docs_docprice"
                          :class="[
                            'form-label-group-label shorter',
                            docs_current.docprice != '' ? 'high' : '',
                          ]"
                          >{{ $t("message.twh.docprice") }}</label
                        >
                        <cleave
                          id="docs_docprice"
                          v-model="docs_current.docprice"
                          :options="cleaveWeight"
                          class="form-control"
                          :placeholder="$t('message.twh.docprice')"
                          autocomplete="off"
                          style="cursor: auto"
                        ></cleave>
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group',
                        ]"
                      >
                        <input
                          type="text"
                          class="form-control"
                          v-model="docs_current.sendername"
                          :placeholder="$t('message.twh.sendername')"
                          autocomplete="off"
                          style="cursor: auto"
                          id="docs_sendername"
                        />
                        <label
                          for="docs_sendername"
                          class="form-label-group-label shorter"
                          >{{ $t("message.twh.sendername") }}</label
                        >
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group shorter',
                        ]"
                      >
                        <datepicker
                          value-type="YYYY-MM-DD"
                          format="DD.MM.YYYY"
                          @focus="docs_current.docdatecreate = ' '"
                          @blur="
                            docs_current.docdatecreate == ' '
                              ? (docs_current.docdatecreate = '')
                              : (docs_current.docdatecreate =
                                  docs_current.docdatecreate)
                          "
                          inputClass="form-control"
                          v-model="docs_current.docdatecreate"
                          :placeholder="$t('message.twh.docdatecreate')"
                          :inputAttr="{ id: 'twh_docdatecreate' }"
                        />
                        <label
                          for="docs_docdatecreate"
                          class="form-label-group-label shorter"
                          :class="
                            docs_current.docdatecreate != '' &&
                            docs_current.docdatecreate != null
                              ? 'topped'
                              : ''
                          "
                          >{{ $t("message.twh.docdatecreate") }}</label
                        >
                      </span>
                    </div>
                  </div>
                  <button
                    @click="save_change_additional_row('docs')"
                    class="btn btn-success"
                  >
                    {{ $t("message.save") }}
                  </button>
                </b-modal>

                <b-modal
                  id="modal-add-permdocs"
                  size="lg"
                  centered
                  :hide-footer="true"
                  :title="$t('message.add') + ' ' + $t('message.twh.permdocs')"
                >
                  <div class="row">
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-1 d-block form-label-group',
                        ]"
                      >
                        <label
                          for="permdocs_recordid"
                          :class="[
                            'form-label-group-label shorter',
                            permdocs_current.recordid != '' ? 'high' : '',
                          ]"
                          >{{ $t("message.twh.recordid") }}</label
                        >
                        <cleave
                          id="permdocs_recordid"
                          v-model="permdocs_current.recordid"
                          :options="cleave"
                          class="form-control"
                          :placeholder="$t('message.twh.recordid')"
                          autocomplete="off"
                          style="cursor: auto"
                        ></cleave>
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-1 d-block form-label-group',
                        ]"
                      >
                        <label
                          for="permdocs_linenum"
                          :class="[
                            'form-label-group-label shorter',
                            permdocs_current.linenum != '' ? 'high' : '',
                          ]"
                          >{{ $t("message.twh.linenum") }}</label
                        >
                        <cleave
                          id="permdocs_linenum"
                          v-model="permdocs_current.linenum"
                          :options="cleave"
                          class="form-control"
                          :placeholder="$t('message.twh.linenum')"
                          autocomplete="off"
                          style="cursor: auto"
                        ></cleave>
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 mt-2 d-block form-label-group ',
                          focused.doctype == true ? 'focused' : '',
                        ]"
                      >
                        <v-select-popup
                          type="doc_type"
                          :placeholder="$t('message.twh.doctype')"
                          v-model="permdocs_current.doctype"
                        />

                        <!-- <v-select id="permdocs_doctype" :options="twh_doctypes" label="display_text" :class="['form-control', typeof permdocs_current.doctype !== 'undefined' && permdocs_current.doctype.value!==''?'vs--selected':'']" @search="fetchDoctypes"  v-model="permdocs_current.doctype" :placeholder="$t('message.twh.doctype')" @focus="focused.doctype=true" @blur="focused.doctype=false">
                                                </v-select>	
                                                <label for="permdocs_doctype" class="form-label-group-label shorter">{{$t('message.twh.doctype')}}</label> -->
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group',
                        ]"
                      >
                        <input
                          type="text"
                          class="form-control"
                          v-model="permdocs_current.docnum"
                          :placeholder="$t('message.twh.docnum')"
                          autocomplete="off"
                          style="cursor: auto"
                          id="permdocs_docnum"
                        />
                        <label
                          for="permdocs_docnum"
                          class="form-label-group-label shorter"
                          >{{ $t("message.twh.docnum") }}</label
                        >
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group shorter',
                        ]"
                      >
                        <datepicker
                          value-type="YYYY-MM-DD"
                          format="DD.MM.YYYY"
                          @focus="permdocs_current.docdate = ' '"
                          @blur="
                            permdocs_current.docdate == ' '
                              ? (permdocs_current.docdate = '')
                              : (permdocs_current.docdate =
                                  permdocs_current.docdate)
                          "
                          inputClass="form-control"
                          v-model="permdocs_current.docdate"
                          :placeholder="$t('message.twh.docdate')"
                          :inputAttr="{ id: 'twh_docdate' }"
                        />
                        <label
                          for="permdocs_docdate"
                          class="form-label-group-label shorter"
                          :class="
                            permdocs_current.docdate != '' &&
                            permdocs_current.docdate != null
                              ? 'topped'
                              : ''
                          "
                          >{{ $t("message.twh.docdate") }}</label
                        >
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group',
                        ]"
                      >
                        <input
                          type="text"
                          class="form-control"
                          v-model="permdocs_current.addpermfirm"
                          :placeholder="$t('message.twh.addpermfirm')"
                          autocomplete="off"
                          style="cursor: auto"
                          id="permdocs_addpermfirm"
                        />
                        <label
                          for="permdocs_addpermfirm"
                          class="form-label-group-label shorter"
                          >{{ $t("message.twh.addpermfirm") }}</label
                        >
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group',
                        ]"
                      >
                        <input
                          type="text"
                          class="form-control"
                          v-model="permdocs_current.custofficerstampnum"
                          :placeholder="$t('message.twh.custofficerstampnum')"
                          autocomplete="off"
                          style="cursor: auto"
                          id="permdocs_custofficerstampnum"
                        />
                        <label
                          for="permdocs_custofficerstampnum"
                          class="form-label-group-label shorter"
                          >{{ $t("message.twh.custofficerstampnum") }}</label
                        >
                      </span>
                    </div>

                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-1 d-block form-label-group',
                        ]"
                      >
                        <label
                          for="permdocs_docnetto"
                          :class="[
                            'form-label-group-label shorter',
                            docs_current.docnetto != '' ? 'high' : '',
                          ]"
                          >{{ $t("message.twh.docnetto") }}</label
                        >
                        <cleave
                          id="permdocs_docnetto"
                          v-model="permdocs_current.docnetto"
                          :options="cleaveWeight"
                          class="form-control"
                          :placeholder="$t('message.twh.docnetto')"
                          autocomplete="off"
                          style="cursor: auto"
                        ></cleave>
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-1 d-block form-label-group',
                        ]"
                      >
                        <label
                          for="permdocs_docbrutto"
                          :class="[
                            'form-label-group-label shorter',
                            docs_current.docbrutto != '' ? 'high' : '',
                          ]"
                          >{{ $t("message.twh.docbrutto") }}</label
                        >
                        <cleave
                          id="permdocs_docbrutto"
                          v-model="permdocs_current.docbrutto"
                          :options="cleaveWeight"
                          class="form-control"
                          :placeholder="$t('message.twh.docbrutto')"
                          autocomplete="off"
                          style="cursor: auto"
                        ></cleave>
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 mt-2 d-block form-label-group ',
                          focused.doctype == true ? 'focused' : '',
                        ]"
                      >
                        <v-select-popup
                          type="currency"
                          :placeholder="$t('message.twh.doccurrencycode')"
                          v-model="permdocs_current.doccurrencycode"
                        />

                        <!-- <v-select id="permdocs_doccurrencycode" :options="currencies" label="display_text" :class="['form-control', typeof permdocs_current.doccurrencycode !== 'undefined' && permdocs_current.doccurrencycode.value!==''?'vs--selected':'']" @search="fetchCurrencies"  v-model="permdocs_current.doccurrencycode" :placeholder="$t('message.twh.doccurrencycode')" @focus="focused.doccurrencycode=true" @blur="focused.doccurrencycode=false">
                                                </v-select>	
                                                <label for="permdocs_doccurrencycode" class="form-label-group-label shorter">{{$t('message.twh.doccurrencycode')}}</label> -->
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-1 d-block form-label-group',
                        ]"
                      >
                        <label
                          for="permdocs_docprice"
                          :class="[
                            'form-label-group-label shorter',
                            docs_current.docprice != '' ? 'high' : '',
                          ]"
                          >{{ $t("message.twh.docprice") }}</label
                        >
                        <cleave
                          id="permdocs_docprice"
                          v-model="permdocs_current.docprice"
                          :options="cleaveWeight"
                          class="form-control"
                          :placeholder="$t('message.twh.docprice')"
                          autocomplete="off"
                          style="cursor: auto"
                        ></cleave>
                      </span>
                    </div>
                  </div>
                  <button
                    @click="create_new_additional_row('permdocs')"
                    class="btn btn-success"
                  >
                    {{ $t("message.add") }}
                  </button>
                </b-modal>
                <b-modal
                  id="modal-edit-permdocs"
                  size="lg"
                  centered
                  :hide-footer="true"
                  :title="$t('message.edit') + ' ' + $t('message.twh.permdocs')"
                >
                  <div class="row">
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-1 d-block form-label-group',
                        ]"
                      >
                        <label
                          for="permdocs_recordid"
                          :class="[
                            'form-label-group-label shorter',
                            permdocs_current.recordid != '' ? 'high' : '',
                          ]"
                          >{{ $t("message.twh.recordid") }}</label
                        >
                        <cleave
                          id="permdocs_recordid"
                          v-model="permdocs_current.recordid"
                          :options="cleave"
                          class="form-control"
                          :placeholder="$t('message.twh.recordid')"
                          autocomplete="off"
                          style="cursor: auto"
                        ></cleave>
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-1 d-block form-label-group',
                        ]"
                      >
                        <label
                          for="permdocs_linenum"
                          :class="[
                            'form-label-group-label shorter',
                            permdocs_current.linenum != '' ? 'high' : '',
                          ]"
                          >{{ $t("message.twh.linenum") }}</label
                        >
                        <cleave
                          id="permdocs_linenum"
                          v-model="permdocs_current.linenum"
                          :options="cleave"
                          class="form-control"
                          :placeholder="$t('message.twh.linenum')"
                          autocomplete="off"
                          style="cursor: auto"
                        ></cleave>
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 mt-2 d-block form-label-group ',
                          focused.doctype == true ? 'focused' : '',
                        ]"
                      >
                        <v-select-popup
                          type="doc_type"
                          :placeholder="$t('message.twh.doctype')"
                          v-model="permdocs_current.doctype"
                        />

                        <!-- <v-select id="permdocs_doctype" :options="twh_doctypes" label="display_text" :class="['form-control', typeof permdocs_current.doctype !== 'undefined' && permdocs_current.doctype.value!==''?'vs--selected':'']" @search="fetchDoctypes"  v-model="permdocs_current.doctype" :placeholder="$t('message.twh.doctype')" @focus="focused.doctype=true" @blur="focused.doctype=false">
                                                </v-select>	
                                                <label for="permdocs_doctype" class="form-label-group-label shorter">{{$t('message.twh.doctype')}}</label> -->
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group',
                        ]"
                      >
                        <input
                          type="text"
                          class="form-control"
                          v-model="permdocs_current.docnum"
                          :placeholder="$t('message.twh.docnum')"
                          autocomplete="off"
                          style="cursor: auto"
                          id="permdocs_docnum"
                        />
                        <label
                          for="permdocs_docnum"
                          class="form-label-group-label shorter"
                          >{{ $t("message.twh.docnum") }}</label
                        >
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group shorter',
                        ]"
                      >
                        <datepicker
                          value-type="YYYY-MM-DD"
                          format="DD.MM.YYYY"
                          @focus="permdocs_current.docdate = ' '"
                          @blur="
                            permdocs_current.docdate == ' '
                              ? (permdocs_current.docdate = '')
                              : (permdocs_current.docdate =
                                  permdocs_current.docdate)
                          "
                          inputClass="form-control"
                          v-model="permdocs_current.docdate"
                          :placeholder="$t('message.twh.docdate')"
                          :inputAttr="{ id: 'twh_docdate' }"
                        />
                        <label
                          for="permdocs_docdate"
                          class="form-label-group-label shorter"
                          :class="
                            permdocs_current.docdate != '' &&
                            permdocs_current.docdate != null
                              ? 'topped'
                              : ''
                          "
                          >{{ $t("message.twh.docdate") }}</label
                        >
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group',
                        ]"
                      >
                        <input
                          type="text"
                          class="form-control"
                          v-model="permdocs_current.addpermfirm"
                          :placeholder="$t('message.twh.addpermfirm')"
                          autocomplete="off"
                          style="cursor: auto"
                          id="permdocs_addpermfirm"
                        />
                        <label
                          for="permdocs_addpermfirm"
                          class="form-label-group-label shorter"
                          >{{ $t("message.twh.addpermfirm") }}</label
                        >
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group',
                        ]"
                      >
                        <input
                          type="text"
                          class="form-control"
                          v-model="permdocs_current.custofficerstampnum"
                          :placeholder="$t('message.twh.custofficerstampnum')"
                          autocomplete="off"
                          style="cursor: auto"
                          id="permdocs_custofficerstampnum"
                        />
                        <label
                          for="permdocs_custofficerstampnum"
                          class="form-label-group-label shorter"
                          >{{ $t("message.twh.custofficerstampnum") }}</label
                        >
                      </span>
                    </div>

                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-1 d-block form-label-group',
                        ]"
                      >
                        <label
                          for="permdocs_docnetto"
                          :class="[
                            'form-label-group-label shorter',
                            docs_current.docnetto != '' ? 'high' : '',
                          ]"
                          >{{ $t("message.twh.docnetto") }}</label
                        >
                        <cleave
                          id="permdocs_docnetto"
                          v-model="permdocs_current.docnetto"
                          :options="cleaveWeight"
                          class="form-control"
                          :placeholder="$t('message.twh.docnetto')"
                          autocomplete="off"
                          style="cursor: auto"
                        ></cleave>
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-1 d-block form-label-group',
                        ]"
                      >
                        <label
                          for="permdocs_docbrutto"
                          :class="[
                            'form-label-group-label shorter',
                            docs_current.docbrutto != '' ? 'high' : '',
                          ]"
                          >{{ $t("message.twh.docbrutto") }}</label
                        >
                        <cleave
                          id="permdocs_docbrutto"
                          v-model="permdocs_current.docbrutto"
                          :options="cleaveWeight"
                          class="form-control"
                          :placeholder="$t('message.twh.docbrutto')"
                          autocomplete="off"
                          style="cursor: auto"
                        ></cleave>
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-2 mt-2 d-block form-label-group ',
                          focused.doctype == true ? 'focused' : '',
                        ]"
                      >
                        <v-select-popup
                          type="currency"
                          :placeholder="$t('message.twh.doccurrencycode')"
                          v-model="permdocs_current.doccurrencycode"
                        />

                        <!-- <v-select id="permdocs_doccurrencycode" :options="currencies" label="display_text" :class="['form-control', typeof permdocs_current.doccurrencycode !== 'undefined' && docs_current.doccurrencycode.value!==''?'vs--selected':'']" @search="fetchCurrencies"  v-model="permdocs_current.doccurrencycode" :placeholder="$t('message.twh.doccurrencycode')" @focus="focused.doccurrencycode=true" @blur="focused.doccurrencycode=false">
                                                </v-select>	
                                                <label for="permdocs_doccurrencycode" class="form-label-group-label shorter">{{$t('message.twh.doccurrencycode')}}</label> -->
                      </span>
                    </div>
                    <div class="col-md-6">
                      <span
                        :class="[
                          'bmd-form-group mb-1 d-block form-label-group',
                        ]"
                      >
                        <label
                          for="permdocs_docprice"
                          :class="[
                            'form-label-group-label shorter',
                            docs_current.docprice != '' ? 'high' : '',
                          ]"
                          >{{ $t("message.twh.docprice") }}</label
                        >
                        <cleave
                          id="permdocs_docprice"
                          v-model="permdocs_current.docprice"
                          :options="cleaveWeight"
                          class="form-control"
                          :placeholder="$t('message.twh.docprice')"
                          autocomplete="off"
                          style="cursor: auto"
                        ></cleave>
                      </span>
                    </div>
                  </div>
                  <button
                    @click="save_change_additional_row('permdocs')"
                    class="btn btn-success"
                  >
                    {{ $t("message.save") }}
                  </button>
                </b-modal>

                <b-modal
                  id="modal-add-recipients"
                  size="sm"
                  centered
                  :hide-footer="true"
                  :title="
                    $t('message.add') + ' ' + $t('message.twh.recipients')
                  "
                >
                  <div class="row">
                    <div class="col-md-12">
                      <span
                        :class="[
                          'bmd-form-group mb-1 d-block form-label-group',
                        ]"
                      >
                        <label
                          for="recipients_recordid"
                          :class="[
                            'form-label-group-label shorter',
                            recipients_current.recordid != '' ? 'high' : '',
                          ]"
                          >{{ $t("message.twh.recordid") }}</label
                        >
                        <cleave
                          id="recipients_recordid"
                          v-model="recipients_current.recordid"
                          :options="cleave"
                          class="form-control"
                          :placeholder="$t('message.twh.recordid')"
                          autocomplete="off"
                          style="cursor: auto"
                        ></cleave>
                      </span>
                    </div>
                    <div class="col-md-12">
                      <span
                        :class="[
                          'bmd-form-group mb-1 d-block form-label-group',
                        ]"
                      >
                        <label
                          for="recipients_linenum"
                          :class="[
                            'form-label-group-label shorter',
                            recipients_current.linenum != '' ? 'high' : '',
                          ]"
                          >{{ $t("message.twh.linenum") }}</label
                        >
                        <cleave
                          id="recipients_linenum"
                          v-model="recipients_current.linenum"
                          :options="cleave"
                          class="form-control"
                          :placeholder="$t('message.twh.linenum')"
                          autocomplete="off"
                          style="cursor: auto"
                        ></cleave>
                      </span>
                    </div>

                    <div class="col-md-12">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group',
                        ]"
                      >
                        <input
                          type="text"
                          class="form-control"
                          v-model="recipients_current.recipientrnn"
                          :placeholder="$t('message.twh.recipientrnn')"
                          autocomplete="off"
                          style="cursor: auto"
                          id="recipients_recipientrnn"
                        />
                        <label
                          for="recipients_recipientrnn"
                          class="form-label-group-label shorter"
                          >{{ $t("message.twh.recipientrnn") }}</label
                        >
                      </span>
                    </div>

                    <div class="col-md-12">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group',
                        ]"
                      >
                        <input
                          type="text"
                          class="form-control"
                          v-model="recipients_current.recipientname"
                          :placeholder="$t('message.twh.recipientname')"
                          autocomplete="off"
                          style="cursor: auto"
                          id="recipients_recipientname"
                        />
                        <label
                          for="recipients_recipientname"
                          class="form-label-group-label shorter"
                          >{{ $t("message.twh.recipientname") }}</label
                        >
                      </span>
                    </div>
                    <div class="col-md-12">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group',
                        ]"
                      >
                        <input
                          type="text"
                          class="form-control"
                          v-model="recipients_current.recipientaddress"
                          :placeholder="$t('message.twh.recipientaddress')"
                          autocomplete="off"
                          style="cursor: auto"
                          id="recipients_recipientaddress"
                        />
                        <label
                          for="recipients_recipientaddress"
                          class="form-label-group-label shorter"
                          >{{ $t("message.twh.recipientaddress") }}</label
                        >
                      </span>
                    </div>
                  </div>
                  <button
                    @click="create_new_additional_row('recipients')"
                    class="btn btn-success"
                  >
                    {{ $t("message.add") }}
                  </button>
                </b-modal>
                <b-modal
                  id="modal-edit-recipients"
                  size="sm"
                  centered
                  :hide-footer="true"
                  :title="
                    $t('message.edit') + ' ' + $t('message.twh.recipients')
                  "
                >
                  <div class="row">
                    <div class="col-md-12">
                      <span
                        :class="[
                          'bmd-form-group mb-1 d-block form-label-group',
                        ]"
                      >
                        <label
                          for="recipients_recordid"
                          :class="[
                            'form-label-group-label shorter',
                            recipients_current.recordid != '' ? 'high' : '',
                          ]"
                          >{{ $t("message.twh.recordid") }}</label
                        >
                        <cleave
                          id="recipients_recordid"
                          v-model="recipients_current.recordid"
                          :options="cleave"
                          class="form-control"
                          :placeholder="$t('message.twh.recordid')"
                          autocomplete="off"
                          style="cursor: auto"
                        ></cleave>
                      </span>
                    </div>
                    <div class="col-md-12">
                      <span
                        :class="[
                          'bmd-form-group mb-1 d-block form-label-group',
                        ]"
                      >
                        <label
                          for="recipients_linenum"
                          :class="[
                            'form-label-group-label shorter',
                            recipients_current.linenum != '' ? 'high' : '',
                          ]"
                          >{{ $t("message.twh.linenum") }}</label
                        >
                        <cleave
                          id="recipients_linenum"
                          v-model="recipients_current.linenum"
                          :options="cleave"
                          class="form-control"
                          :placeholder="$t('message.twh.linenum')"
                          autocomplete="off"
                          style="cursor: auto"
                        ></cleave>
                      </span>
                    </div>

                    <div class="col-md-12">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group',
                        ]"
                      >
                        <input
                          type="text"
                          class="form-control"
                          v-model="recipients_current.recipientrnn"
                          :placeholder="$t('message.twh.recipientrnn')"
                          autocomplete="off"
                          style="cursor: auto"
                          id="recipients_recipientrnn"
                        />
                        <label
                          for="recipients_recipientrnn"
                          class="form-label-group-label shorter"
                          >{{ $t("message.twh.recipientrnn") }}</label
                        >
                      </span>
                    </div>

                    <div class="col-md-12">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group',
                        ]"
                      >
                        <input
                          type="text"
                          class="form-control"
                          v-model="recipients_current.recipientname"
                          :placeholder="$t('message.twh.recipientname')"
                          autocomplete="off"
                          style="cursor: auto"
                          id="recipients_recipientname"
                        />
                        <label
                          for="recipients_recipientname"
                          class="form-label-group-label shorter"
                          >{{ $t("message.twh.recipientname") }}</label
                        >
                      </span>
                    </div>
                    <div class="col-md-12">
                      <span
                        :class="[
                          'bmd-form-group mb-2 d-block form-label-group',
                        ]"
                      >
                        <input
                          type="text"
                          class="form-control"
                          v-model="recipients_current.recipientaddress"
                          :placeholder="$t('message.twh.recipientaddress')"
                          autocomplete="off"
                          style="cursor: auto"
                          id="recipients_recipientaddress"
                        />
                        <label
                          for="recipients_recipientaddress"
                          class="form-label-group-label shorter"
                          >{{ $t("message.twh.recipientaddress") }}</label
                        >
                      </span>
                    </div>
                  </div>
                  <button
                    @click="save_change_additional_row('recipients')"
                    class="btn btn-success"
                  >
                    {{ $t("message.save") }}
                  </button>
                </b-modal>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      cleave: {
        numeral: true,
        numeralDecimalMark: "",
        delimiter: "",
      },
      cleaveWeight: {
        numeral: true,
        numeralPositiveOnly: true,
        blocks: [24],
        numeralDecimalScale: 6,
      },
      focused: {
        regcountry: false,
        doctype: false,
        doccurrencycode: false,
      },
      countries: [],
      twh_doctypes: [],
      currencies: [],
      twh: {
        docid: "",
        notifnumint: "",
        blankinnum: "",
        cbxnum: "",
        transtype: "",
        regcountry: { value: "" },
        transportmark: "",
        transportnum: "",
        trailernum: "",
        carriername: "",
        carrierrnn: "",
        drivername: "",
        driverpasspnum: "",
        driverpasspdate: "",
        driverpasspplace: "",
        goodsforbidden: "",
        placedate: "",
        noticedate: "",
        custmark: "",
        regnum: "",
        custofficerstampnum: "",
        custofficername: "",
        specialist: "",
        shassi: "",
        driverdocname: "",
        dcodepto: "",
        namepto: "",
        carrieraddress: "",
        regcountrycode: "",
        purpose: "",
        notifnum: "",
        createyear: "",
        trisleave: "",
        carrierstamp1: "",
        carrierstamp2: "",
        placename: "",
        dateout: "",
        damage: "",
        breachiden: "",
        removeiden: "",
        imposiden: "",
        bi_amount: "",
        bi_num: "",
        ri_amount: "",
        ri_num: "",
        ii_amount: "",
        ii_num: "",
        driveroffice: "",
        damcomment: "",
        newdoc: "",
        isnew: "",
        drivertype: "",
        docscurrencycode: "",
        transcategorycode: "",
        twhplace: "",
        notifcuststatus: "",
        notifcuststatusdate: "",
        pr_vygr: "",
        docnotificationcustdocs: [],
        docnotificationdocs: [],
        docnotificationpermdocs: [],
        docnotificationrecipients: [],
        documents: [],
        cwcardinmain: [],
        cwcardoutmain: [],
      },
      custdocs_fields: [
        {
          key: "recordid",
          label: this.$t("message.twh.recordid"),
        },
        {
          key: "linenum",
          label: this.$t("message.twh.linenum"),
        },
        {
          key: "doctype",
          label: this.$t("message.twh.doctype"),
        },
        {
          key: "docnum",
          label: this.$t("message.twh.docnum"),
        },
        {
          key: "docdate",
          label: this.$t("message.twh.docdate"),
        },
        {
          key: "addpermfirm",
          label: this.$t("message.twh.addpermfirm"),
        },
        {
          key: "custofficerstampnum",
          label: this.$t("message.twh.custofficerstampnum"),
        },
        {
          key: "custofficername",
          label: this.$t("message.twh.custofficername"),
        },
        {
          key: "ny",
          label: this.$t("message.twh.ny"),
        },
        {
          key: "nj",
          label: this.$t("message.twh.nj"),
        },
        {
          key: "nn",
          label: this.$t("message.twh.nn"),
        },
        {
          key: "docdkd",
          label: this.$t("message.twh.docdkd"),
        },
        {
          key: "actions",
          label: "",
        },
      ],
      docs_fields: [
        {
          key: "recordid",
          label: this.$t("message.twh.recordid"),
        },
        {
          key: "linenum",
          label: this.$t("message.twh.linenum"),
        },
        {
          key: "doctype",
          label: this.$t("message.twh.doctype"),
        },
        {
          key: "docnum",
          label: this.$t("message.twh.docnum"),
        },
        {
          key: "docdate",
          label: this.$t("message.twh.docdate"),
        },
        {
          key: "doccomment",
          label: this.$t("message.twh.doccomment"),
        },
        {
          key: "docfirm",
          label: this.$t("message.twh.docfirm"),
        },
        {
          key: "docnetto",
          label: this.$t("message.twh.docnetto"),
        },
        {
          key: "docbrutto",
          label: this.$t("message.twh.docbrutto"),
        },
        {
          key: "doccurrencycode",
          label: this.$t("message.twh.doccurrencycode"),
        },
        {
          key: "docprice",
          label: this.$t("message.twh.docprice"),
        },
        {
          key: "sendername",
          label: this.$t("message.twh.sendername"),
        },
        {
          key: "docdatecreate",
          label: this.$t("message.twh.docdatecreate"),
        },
        {
          key: "actions",
          label: "",
        },
      ],
      permdocs_fields: [
        {
          key: "recordid",
          label: this.$t("message.twh.recordid"),
        },
        {
          key: "linenum",
          label: this.$t("message.twh.linenum"),
        },
        {
          key: "doctype",
          label: this.$t("message.twh.doctype"),
        },
        {
          key: "docnum",
          label: this.$t("message.twh.docnum"),
        },
        {
          key: "docdate",
          label: this.$t("message.twh.docdate"),
        },
        {
          key: "addpermfirm",
          label: this.$t("message.twh.addpermfirm"),
        },
        {
          key: "custofficerstampnum",
          label: this.$t("message.twh.custofficerstampnum"),
        },
        {
          key: "docnetto",
          label: this.$t("message.twh.docnetto"),
        },
        {
          key: "docbrutto",
          label: this.$t("message.twh.docbrutto"),
        },
        {
          key: "doccurrencycode",
          label: this.$t("message.twh.doccurrencycode"),
        },
        {
          key: "docprice",
          label: this.$t("message.twh.docprice"),
        },
        {
          key: "actions",
          label: "",
        },
      ],
      recipients_fields: [
        {
          key: "recordid",
          label: this.$t("message.twh.recordid"),
        },
        {
          key: "linenum",
          label: this.$t("message.twh.linenum"),
        },
        {
          key: "recipientrnn",
          label: this.$t("message.twh.recipientrnn"),
        },
        {
          key: "recipientname",
          label: this.$t("message.twh.recipientname"),
        },
        {
          key: "recipientaddress",
          label: this.$t("message.twh.recipientaddress"),
        },
        {
          key: "actions",
          label: "",
        },
      ],
      current_edit_index: false,
      custdocs_current: {
        recordid: "",
        linenum: "",
        doctype: { value: "", display_text: "" },
        docnum: "",
        docdate: "",
        addpermfirm: "",
        custofficerstampnum: "",
        custofficername: "",
        ny: "",
        nj: "",
        nn: "",
        docdkd: "",
      },
      docs_current: {
        recordid: "",
        linenum: "",
        doctype: { value: "", display_text: "" },
        docnum: "",
        docdate: "",
        doccomment: "",
        docfirm: "",
        docnetto: "",
        docbrutto: "",
        doccurrencycode: { value: "", display_text: "" },
        docprice: "",
        sendername: "",
        docdatecreate: "",
      },
      permdocs_current: {
        recordid: "",
        linenum: "",
        doctype: { value: "", display_text: "" },
        docnum: "",
        docdate: "",
        addpermfirm: "",
        custofficerstampnum: "",
        docnetto: "",
        docbrutto: "",
        doccurrencycode: { value: "", display_text: "" },
        docprice: "",
      },
      recipients_current: {
        recordid: "",
        linenum: "",
        recipientrnn: "",
        recipientname: "",
        recipientaddress: "",
      },
    };
  },
  methods: {
    save_change_additional_row(type) {
      switch (type) {
        case "custdocs":
          this.$set(
            this.twh.docnotificationcustdocs,
            this.current_edit_index,
            this.custdocs_current,
          );
          break;
        case "docs":
          this.$set(
            this.twh.docnotificationdocs,
            this.current_edit_index,
            this.docs_current,
          );
          break;
        case "permdocs":
          this.$set(
            this.twh.docnotificationpermdocs,
            this.current_edit_index,
            this.permdocs_current,
          );
          break;
        case "recipients":
          this.$set(
            this.twh.docnotificationrecipients,
            this.current_edit_index,
            this.recipients_current,
          );
          break;
      }
      this.$bvModal.hide("modal-edit-" + type);
    },
    create_new_additional_row(type) {
      switch (type) {
        case "custdocs":
          this.twh.docnotificationcustdocs.push(this.custdocs_current);
          this.$bvModal.hide("modal-add-" + type);
          this.custdocs_current = {
            recordid: "",
            linenum: "",
            doctype: { value: "", display_text: "" },
            docnum: "",
            docdate: "",
            addpermfirm: "",
            custofficerstampnum: "",
            custofficername: "",
            ny: "",
            nj: "",
            nn: "",
            docdkd: "",
          };
          break;
        case "docs":
          this.twh.docnotificationdocs.push(this.docs_current);
          this.$bvModal.hide("modal-add-" + type);
          this.docs_current = {
            recordid: "",
            linenum: "",
            doctype: { value: "", display_text: "" },
            docnum: "",
            docdate: "",
            doccomment: "",
            docfirm: "",
            docnetto: "",
            docbrutto: "",
            doccurrencycode: { value: "", display_text: "" },
            docprice: "",
            sendername: "",
            docdatecreate: "",
          };
          break;
        case "permdocs":
          this.twh.docnotificationpermdocs.push(this.permdocs_current);
          this.$bvModal.hide("modal-add-" + type);
          this.permdocs_current = {
            recordid: "",
            linenum: "",
            doctype: { value: "", display_text: "" },
            docnum: "",
            docdate: "",
            addpermfirm: "",
            custofficerstampnum: "",
            docnetto: "",
            docbrutto: "",
            doccurrencycode: { value: "", display_text: "" },
            docprice: "",
          };
          break;
        case "recipients":
          this.twh.docnotificationrecipients.push(this.recipients_current);
          this.$bvModal.hide("modal-add-" + type);
          this.recipients_current = {
            recordid: "",
            linenum: "",
            recipientrnn: "",
            recipientname: "",
            recipientaddress: "",
          };
          break;
      }
    },
    /**
     * shows edit form of selected row from additional table of type
     */
    edit_additional_row(type, index) {
      this.$bvModal.show("modal-edit-" + type);
      this.current_edit_index = index;
      switch (type) {
        case "custdocs":
          this.custdocs_current = {
            ...this.twh.docnotificationcustdocs[index],
          };
          break;
        case "docs":
          this.docs_current = { ...this.twh.docnotificationdocs[index] };
          break;
        case "permdocs":
          this.permdocs_current = {
            ...this.twh.docnotificationpermdocs[index],
          };
          break;
        case "recipients":
          this.recipients_current = {
            ...this.twh.docnotificationrecipients[index],
          };
          break;
      }
    },
    /**
     * deletes selected row from additional table of type
     */
    delete_additional_row(type, index) {
      switch (type) {
        case "custdocs":
          this.twh.docnotificationcustdocs.splice(index, 1);
          break;
        case "docs":
          this.twh.docnotificationdocs.splice(index, 1);
          break;
        case "permdocs":
          this.twh.docnotificationpermdocs.splice(index, 1);
          break;
        case "recipients":
          this.twh.docnotificationrecipients.splice(index, 1);
          break;
      }
    },
    /**
     * adds additional row to additional table by type
     */
    add_additional_row(type) {
      this.$bvModal.show("modal-add-" + type);
    },
    save() {
      //split regcountry into regcountrycode and regcountry
      // let form = new FormData
      // form.append('docid', this.twh.docid)
      // form.append('notifnumint', this.twh.notifnumint)
      // form.append('blankinnum', this.twh.blankinnum)
      // form.append('cbxnum', this.twh.cbxnum)
      // form.append('transtype', this.twh.transtype)
      // if(typeof this.twh.regcountry.display_text !== 'undefined')
      //     form.append('regcountry', this.twh.regcountry.display_text)
      // else
      //     form.append('regcountry', '')
      // if(typeof this.twh.regcountry.value !== 'undefined')
      //     form.append('regcountrycode', this.twh.regcountry.value)
      // else
      //     form.append('regcountrycode', '')
      // form.append('transportmark', this.twh.transportmark)
      // form.append('transportnum', this.twh.transportnum)
      // form.append('trailernum', this.twh.trailernum)
      // form.append('carriername', this.twh.carriername)
      // form.append('carrierrnn', this.twh.carrierrnn)
      // form.append('drivername', this.twh.drivername)
      // form.append('driverpasspnum', this.twh.driverpasspnum)
      // form.append('driverpasspdate', this.twh.driverpasspdate)
      // form.append('driverpasspplace', this.twh.driverpasspplace)
      // form.append('goodsforbidden', this.twh.goodsforbidden)
      // form.append('placedate', this.twh.placedate)
      // form.append('noticedate', this.twh.noticedate)
      // form.append('custmark', this.twh.custmark)
      // form.append('regnum', this.twh.regnum)
      // form.append('custofficerstampnum', this.twh.custofficerstampnum)
      // form.append('custofficername', this.twh.custofficername)
      // form.append('specialist', this.twh.specialist)
      // form.append('shassi', this.twh.shassi)
      // form.append('driverdocname', this.twh.driverdocname)
      // form.append('dcodepto', this.twh.dcodepto)
      // form.append('namepto', this.twh.namepto)
      // form.append('carrieraddress', this.twh.carrieraddress)
      // form.append('regcountrycode', this.twh.regcountrycode)
      // form.append('purpose', this.twh.purpose)
      // form.append('notifnum', this.twh.notifnum)
      // form.append('createyear', this.twh.createyear)
      // form.append('trisleave', this.twh.trisleave)
      // form.append('carrierstamp1', this.twh.carrierstamp1)
      // form.append('carrierstamp2', this.twh.carrierstamp2)
      // form.append('placename', this.twh.placename)
      // form.append('dateout', this.twh.dateout)
      // form.append('damage', this.twh.damage)
      // form.append('breachiden', this.twh.breachiden)
      // form.append('removeiden', this.twh.removeiden)
      // form.append('imposiden', this.twh.imposiden)
      // form.append('bi_amount', this.twh.bi_amount)
      // form.append('bi_num', this.twh.bi_num)
      // form.append('ri_amount', this.twh.ri_amount)
      // form.append('ri_num', this.twh.ri_num)
      // form.append('ii_amount', this.twh.ii_amount)
      // form.append('ii_num', this.twh.ii_num)
      // form.append('driveroffice', this.twh.driveroffice)
      // form.append('damcomment', this.twh.damcomment)
      // form.append('newdoc', this.twh.newdoc)
      // form.append('isnew', this.twh.isnew)
      // form.append('drivertype', this.twh.drivertype)
      // form.append('docscurrencycode', this.twh.docscurrencycode)
      // form.append('transcategorycode', this.twh.transcategorycode)
      // form.append('twhplace', this.twh.twhplace)
      // form.append('notifcuststatus', this.twh.notifcuststatus)
      // form.append('notifcuststatusdate', this.twh.notifcuststatusdate)
      // form.append('pr_vygr', this.twh.pr_vygr)

      axios
        .post(window.base + "/document/addDocNotification", this.twh)
        .then((r) => {
          this.$router.push({ name: "twh-index" });
        });
    },
    fetchCurrencies(search, loading) {
      this.getLibrary("currency", search, 100);
    },
    fetchCountries(search, loading) {
      this.getLibrary("country", search, 100);
    },
    fetchDoctypes(search, loading) {
      this.getLibrary("twh_doctype", search, 100);
    },
    getLibrary(type, query, qty) {
      query = query.toLowerCase();
      axios
        .get(
          window.base +
            "/library?type=" +
            type +
            "&query=" +
            query +
            "&qty=" +
            qty +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          var var_name = type;
          if (type[type.length - 1] == "s") {
            var_name = type + "es";
          } else if (type[type.length - 1] == "y") {
            var_name = type.substring(0, type.length - 1) + "ies";
          } else {
            var_name = type + "s";
          }
          if (type == "packaging") var_name = "type_packagings";
          this.$data[var_name] = [];
          response.data.forEach((item) => {
            if (type == "packaging" || type == "transporttype")
              this.$data[var_name].push({
                value: item.value,
                display_text: item.value + " - " + item.display_text,
              });
            else this.$data[var_name].push(item);
          });
          // this.$data[var_name] = response.data
        });
    },
  },
  mounted() {
    this.fetchCountries("");
    this.fetchDoctypes("");
    this.fetchCurrencies("");
  },
  computed: {
    user_id() {
      return this.$store.state.user.id;
    },
    locale() {
      var locale = this.$i18n.locale;
      var _this = this;
      switch (locale) {
        case "cn":
          locale = "zh-CN";
          break;
        case "en":
          locale = "en-US";
          break;
      }
      return locale;
    },
  },
  watch: {},
};
</script>
